// Ultimate Card Game (UCG) - Unified Sound Registry
// Single Source of Truth for all game audio, per-entity configuration,
// and the Sound Review & Management Suite (http://localhost:3000/tools/sound-review/).

export const SOUND_REGISTRY = {
  "version": 2,
  "units": {
    "Marine": {
      "name": "Marine",
      "race": "Human",
      "attack": {
        "label": "Angriff (Gauss-Gewehr)",
        "files": [
          "more/foley/body_hit_02.m4a"
        ],
        "volume": 0.7,
        "randomPitch": true,
        "pitchRange": 0.08
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Hero_Kill_001.m4a",
          "even more sounds/Hero_Attack_002.m4a",
          "even more sounds/Hero_Attack_003.m4a"
        ],
        "volume": 0.9
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/Hero_Die_001.m4a",
          "even more sounds/player/paino.m4a"
        ],
        "volume": 0.8
      }
    },
    "TeslaWalker": {
      "name": "Tesla Walker",
      "race": "Human",
      "attack": {
        "label": "Angriff (Tesla-Zap)",
        "files": [
          "baked/tesla_zap.m4a"
        ],
        "volume": 1.5
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "more/weapons/sword_2.m4a"
        ],
        "volume": 0.2
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/motions_and_transitions/low_frequency_flutter_fx_03.m4a"
        ],
        "volume": 0.75
      },
      "hyperTesla": {
        "label": "Hyper Tesla Entladung",
        "files": [
          "baked/hyper_tesla.m4a"
        ],
        "volume": 0.8
      }
    },
    "DevilPatrol": {
      "name": "Devil Patrol",
      "race": "Human",
      "attack": {
        "label": "Angriff (Flammenwerfer)",
        "files": [
          "more/weapons/flame_thrower_loop.m4a"
        ],
        "volume": 0.7
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Human/Human_Evil_02.mp3"
        ],
        "volume": 0.8
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/80-CC0-creature-SFX/scream_02.ogg"
        ],
        "volume": 0.35
      }
    },
    "WheelieBomber": {
      "name": "Wheelie Bomber",
      "race": "Human",
      "attack": {
        "label": "Detonation",
        "files": [
          "lowFrequency_explosion_001.ogg"
        ],
        "volume": 1
      },
      "spawn": {
        "label": "Losfahren (Motor)",
        "files": [
          "baked/wheelie_drive.m4a"
        ],
        "volume": 0.7
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/explosions/explosion_6.m4a"
        ],
        "volume": 0.8
      }
    },
    "Panzer": {
      "name": "Panzer",
      "race": "Human",
      "attack": {
        "label": "Angriff (Kanone)",
        "files": [
          "panzer.m4a"
        ],
        "volume": 0.6
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Human/Human_Good_26.mp3",
          "more/people/taxi_call_2.m4a"
        ],
        "volume": 0.75
      },
      "death": {
        "label": "Tod",
        "files": [
          "explosionCrunch_000.ogg",
          "explosionCrunch_004.ogg"
        ],
        "volume": 0.55
      }
    },
    "Rocketship": {
      "name": "Rocketship",
      "race": "Human",
      "attack": {
        "label": "Angriff (Raketensalve)",
        "files": [
          "more/motions_and_transitions/air_reverse_burst_3.m4a"
        ],
        "volume": 0.45
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "more/sci_fi/jet_pack_pass_1.m4a"
        ],
        "volume": 0.2
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/explosions/explosion_4.m4a"
        ],
        "volume": 0.6
      }
    },
    "DeployableCannon": {
      "name": "Deployable Cannon",
      "race": "Human",
      "attack": {
        "label": "Angriff (Autokanone)",
        "files": [
          "explosion_02.ogg"
        ],
        "volume": 0.9
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "more/weapons/sword_1.m4a"
        ],
        "volume": 0.2
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/motions_and_transitions/low_frequency_flutter_fx_03.m4a",
          "lowFrequency_explosion_001.ogg"
        ],
        "volume": 0.8
      }
    },
    "Shade": {
      "name": "Shade",
      "race": "Human",
      "attack": {
        "label": "Angriff (Gedämpfter Schuss)",
        "files": [
          "more/weapons/gun_silencer.m4a"
        ],
        "volume": 0.05
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "more/weapons/gun_shell_concrete.m4a"
        ],
        "volume": 0.7
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/foley/body_hit_01.m4a",
          "more/foley/body_hit_02.m4a",
          "more/foley/body_hit_03.m4a",
          "more/foley/body_hit_04.m4a"
        ],
        "volume": 0.8
      }
    },
    "A9Piranha": {
      "name": "A9 Piranha",
      "race": "Human",
      "attack": {
        "label": "Angriff (Dual Autokanone)",
        "files": [
          "more/foley/body_hit_02.m4a"
        ],
        "volume": 0.8
      },
      "spawn": {
        "label": "Triebwerk-Loop",
        "files": [
          "even more sounds/qubodup-rts_warsounds_v2/heli/heli.template.m4a"
        ],
        "volume": 0.8
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/explosions/explosion_4.m4a",
          "more/explosions/explosion_5.m4a",
          "more/explosions/explosion_6.m4a"
        ],
        "volume": 0.55
      }
    },
    "A9Grizzly": {
      "name": "A9 Grizzly",
      "race": "Human",
      "attack": {
        "label": "Angriff (Aufklärungs-Autokanone)",
        "files": [
          "more/weapons/gun_holster_1.m4a"
        ],
        "volume": 0.8
      },
      "spawn": {
        "label": "Motor-Start",
        "files": [
          "even more sounds/Archer_See_001.m4a"
        ],
        "volume": 0.7
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/explosions/explosion_4.m4a",
          "more/explosions/explosion_5.m4a"
        ],
        "volume": 0.6
      }
    },
    "A9Pigeon": {
      "name": "A9 Pigeon",
      "race": "Human",
      "attack": {
        "label": "Angriff (30mm Chin Gatling)",
        "files": [
          "more/foley/body_hit_03.m4a"
        ],
        "volume": 0.58,
        "randomPitch": true,
        "pitchRange": 0.1
      },
      "bombDrop": {
        "label": "Bombenabwurf (Hover Release)",
        "files": [
          "more/motions_and_transitions/air_reverse_burst_2.m4a"
        ],
        "volume": 0.7,
        "randomPitch": true,
        "pitchRange": 0.06
      },
      "bombExplosion": {
        "label": "Bomben-Aufschlag (100 DMG Splash)",
        "files": [
          "more/explosions/explosion_5.m4a",
          "more/explosions/explosion_6.m4a"
        ],
        "volume": 0.85,
        "randomPitch": true,
        "pitchRange": 0.08
      },
      "spawn": {
        "label": "Triebwerk-Schub & Tauben-Start",
        "files": [
          "more/sci_fi/jet_pack_pass_1.m4a"
        ],
        "volume": 0.35
      },
      "death": {
        "label": "Tod (Explosion & Taubenschwarm)",
        "files": [
          "more/animals/bird_flying.m4a",
          "more/animals/bird_dove.m4a",
          "more/explosions/explosion_4.m4a"
        ],
        "volume": 0.75
      }
    },
    "TheSalvageCompany": {
      "name": "The Salvage Company",
      "race": "Human",
      "attack": {
        "label": "Salvage Drop",
        "files": [
          "lowFrequency_explosion_000.ogg"
        ],
        "volume": 0.45
      },
      "spawn": {
        "label": "Ausspielen (Horn)",
        "files": [
          "more/transportation/horn_fire_engine.m4a"
        ],
        "volume": 0.7
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/explosions/explosion_3.m4a",
          "more/explosions/explosion_4.m4a",
          "more/explosions/explosion_5.m4a",
          "more/explosions/explosion_6.m4a"
        ],
        "volume": 0.55
      }
    },
    "Orchestra": {
      "name": "Orchestra",
      "race": "Human",
      "attack": {
        "label": "Angriff (Artillerie-Rakete)",
        "files": [
          "more/sci_fi/jet_pack_pass_1.m4a"
        ],
        "volume": 0.35,
        "randomPitch": true,
        "pitchRange": 0.06
      },
      "spawn": {
        "label": "Funkspruch (Artillery Ready)",
        "files": [
          "even more sounds/qubodup-rts_warsounds_v2/artil/artil.ready.m4a"
        ],
        "volume": 0.8,
        "randomPitch": true,
        "pitchRange": 0.05
      },
      "death": {
        "label": "Tod (Explosion & Funkabriss)",
        "files": [
          "more/explosions/explosion_3.m4a",
          "more/explosions/explosion_4.m4a",
          "more/explosions/explosion_5.m4a",
          "even more sounds/qubodup-rts_warsounds_v2/artil/artil.die.m4a"
        ],
        "volume": 0.55
      }
    },
    "HotHand": {
      "name": "Hot Hand",
      "race": "Human",
      "attack": {
        "label": "Angriff (Faustschlag-Treffer)",
        "files": [
          "more/impacts_and_crashes/bullet_impact_body_2.m4a",
          "more/foley/body_hit_04.m4a",
          "more/foley/body_hit_05.m4a",
          "more/foley/body_hit_10.m4a",
          "more/foley/body_hit_11.m4a"
        ],
        "volume": 0.85,
        "randomPitch": true,
        "pitchRange": 0.08
      },
      "spawn": {
        "label": "Spawn (Female Exclaim)",
        "files": [
          "even more sounds/PSE Game Audio Sound Pack/VOXEfrt_Female Exclaim02_PSE_SL-FL_ZQ93X.m4a"
        ],
        "volume": 0.95
      },
      "death": {
        "label": "Tod (Gasp)",
        "files": [
          "more/people/gasp_2.m4a",
          "more/people/gasp_1.m4a"
        ],
        "volume": 0.85
      }
    },
    "PinkBeret": {
      "name": "Pink Beret",
      "race": "Human",
      "attack": {
        "label": "Waffe feuern (Pistolenschuss)",
        "files": [
          "more/weapons/gun_hand_shot_1.m4a"
        ],
        "volume": 0.4,
        "randomPitch": true,
        "pitchRange": 0.08
      },
      "rocket_launch": {
        "label": "Rakete abfeuern (RPG-7 Launch)",
        "files": [
          "more/motions_and_transitions/air_reverse_burst_2.m4a"
        ],
        "volume": 0.85,
        "randomPitch": true,
        "pitchRange": 0.06
      },
      "rocket_impact": {
        "label": "Raketen-Aufschlag (Spezial-Explosion)",
        "files": [
          "baked/pink_beret_rocket_impact.m4a"
        ],
        "volume": 0.8,
        "randomPitch": true,
        "pitchRange": 0.05
      },
      "kiss": {
        "label": "Kuss (Handkuss & Smooch)",
        "files": [
          "more/people/kiss_1.m4a",
          "more/people/kiss_2.m4a"
        ],
        "volume": 0.95,
        "randomPitch": true,
        "pitchRange": 0.05
      },
      "heart_pop": {
        "label": "Herz-Pop (Ballon-Pop & Herzregen)",
        "files": [
          "more/misc/balloon_pop.m4a"
        ],
        "volume": 0.85,
        "randomPitch": true,
        "pitchRange": 0.08
      },
      "spawn": {
        "label": "Spawn (Catwalk Auftritt & Jubel)",
        "files": [
          "more/impacts_and_crashes/arrow_body_impact.m4a"
        ],
        "volume": 0.55,
        "randomPitch": true,
        "pitchRange": 0.05
      },
      "death": {
        "label": "Tod (Kiss & Pop Kombo)",
        "files": [
          "more/people/kiss_1.m4a"
        ],
        "volume": 0.95
      }
    },
    "Hacker": {
      "name": "Hacker",
      "race": "Human",
      "attack": {
        "label": "Kabel-Harune (Disrupt)",
        "files": [
          "more/sci_fi/hacker_harpoon.m4a"
        ],
        "volume": 0.85
      },
      "spawn": {
        "label": "Spawn (Cyber Uplink)",
        "files": [
          "more/sci_fi/scanner_beam_03.m4a"
        ],
        "volume": 0.6
      },
      "reveal": {
        "label": "Hand-Reveal Chime",
        "files": [
          "more/sci_fi/mid_frequency_flutter_fx_01.m4a"
        ],
        "volume": 0.75
      },
      "transcendence": {
        "label": "Hyper Transzendenz",
        "files": [
          "more/sci_fi/hacker_transcendence.m4a"
        ],
        "volume": 0.75
      },
      "death": {
        "label": "Tod (System Failed)",
        "files": [
          "more/sci_fi/hacker_death.m4a",
          "more/mechtech/computer_mouse.m4a"
        ],
        "volume": 0.9
      }
    },
    "DefectiveLoaf": {
      "name": "Defective Loaf",
      "race": "Sul",
      "attack": {
        "label": "Tentakel-Tether",
        "files": [
          "even more sounds/generic_sounds/itemback.m4a"
        ],
        "volume": 0.2
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/80-CC0-creature-SFX/alien_01.ogg",
          "even more sounds/80-CC0-creature-SFX/alien_02.ogg",
          "even more sounds/80-CC0-creature-SFX/alien_03.ogg",
          "even more sounds/80-CC0-creature-SFX/alien_04.ogg"
        ],
        "volume": 0.6
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Alien/Alien_Funny_22.mp3"
        ],
        "volume": 0.8
      }
    },
    "RejectedLoaf": {
      "name": "Rejected Loaf",
      "race": "Sul",
      "attack": {
        "label": "Angriff (Schuss)",
        "files": [
          "more/foley/body_hit_02.m4a"
        ],
        "volume": 0.7
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "baked/sul_spawn.m4a"
        ],
        "volume": 0.6
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/foley/body_hit_02.m4a",
          "more/foley/body_hit_03.m4a"
        ],
        "volume": 0.5
      }
    },
    "ApostateLoaf": {
      "name": "Apostate Loaf",
      "race": "Sul",
      "attack": {
        "label": "Sporen-Mörser",
        "files": [
          "more/sci_fi/liquid_drops_fx_01.m4a",
          "more/sci_fi/liquid_drops_fx_02.m4a"
        ],
        "volume": 0.15
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/80-CC0-creature-SFX/alien_05.ogg"
        ],
        "volume": 0.6
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Alien/Alien_Funny_22.mp3"
        ],
        "volume": 0.6
      }
    },
    "DelvingPillar": {
      "name": "Delving Pillar",
      "race": "Sul",
      "attack": {
        "label": "Angriff (Stachel-Stoß)",
        "files": [
          "more/motions_and_transitions/air_reverse_burst_3.m4a"
        ],
        "volume": 0.6
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Alien/Alien_Funny_14.mp3"
        ],
        "volume": 0.6
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Alien/Alien_Funny_01.mp3"
        ],
        "volume": 0.6
      }
    },
    "ForgottenLoaf": {
      "name": "Forgotten Loaf",
      "race": "Sul",
      "attack": {
        "label": "Angriff",
        "files": [
          "even more sounds/80-CC0-creature-SFX/slime_01.ogg"
        ],
        "volume": 0.55
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/80-CC0-creature-SFX/slime_02.ogg"
        ],
        "volume": 0.55
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/80-CC0-creature-SFX/slime_03.ogg"
        ],
        "volume": 0.55
      }
    },
    "HarvestingPillar": {
      "name": "Harvesting Pillar",
      "race": "Sul",
      "attack": {
        "label": "Dual-Tether Life Siphon",
        "files": [
          "more/motions_and_transitions/sweep_motion.m4a"
        ],
        "volume": 0.25
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/80-CC0-creature-SFX/eat_01.ogg"
        ],
        "volume": 0.6
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/80-CC0-creature-SFX/grunt_04.ogg"
        ],
        "volume": 0.7
      }
    },
    "ProcessingPillar": {
      "name": "Processing Pillar",
      "race": "Sul",
      "attack": {
        "label": "Plasma-Entladung",
        "files": [
          "baked/processing_pillar.m4a"
        ],
        "volume": 0.7
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Alien/Alien_Scientist_06.mp3"
        ],
        "volume": 0.6
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/80-CC0-creature-SFX/weird_03.ogg",
          "even more sounds/80-CC0-creature-SFX/roar_02.ogg"
        ],
        "volume": 0.8
      }
    },
    "ClaimingPillar": {
      "name": "Claiming Pillar",
      "race": "Sul",
      "spawn": {
        "label": "Eruption",
        "files": [
          "baked/sul_spawn.m4a",
          "more/impacts_and_crashes/debris_dirt_and_earth_01.m4a"
        ],
        "volume": 0.8
      },
      "death": {
        "label": "Flüssigkeits-Ruptur",
        "files": [
          "even more sounds/80-CC0-creature-SFX/weird_03.ogg",
          "weird_04.ogg"
        ],
        "volume": 0.8
      }
    },
    "PreserverLock": {
      "name": "Preserver Lock",
      "race": "Sul",
      "attack": {
        "label": "Beam Pulse",
        "files": [
          "baked/preserver_beam.m4a"
        ],
        "volume": 0.25,
        "durationMs": 400
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/80-CC0-creature-SFX/misc_05.ogg"
        ],
        "volume": 0.6
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/80-CC0-RPG-SFX/creature_misc_03.ogg"
        ],
        "volume": 0.8
      }
    },
    "BastionLock": {
      "name": "Bastion Lock",
      "race": "Sul",
      "attack": {
        "label": "Blue Beam Pulse",
        "files": [
          "even more sounds/Sci-Fi Sound Library/Mp3/Laser/Laser_01.mp3",
          "even more sounds/Sci-Fi Sound Library/Mp3/Laser/Laser_02.mp3",
          "even more sounds/Sci-Fi Sound Library/Mp3/Laser/Laser_03.mp3",
          "even more sounds/Sci-Fi Sound Library/Mp3/Laser/Laser_04.mp3",
          "even more sounds/Sci-Fi Sound Library/Mp3/Laser/Laser_06.mp3",
          "even more sounds/Sci-Fi Sound Library/Mp3/Laser/Laser_05.mp3",
          "even more sounds/Sci-Fi Sound Library/Mp3/Laser/Laser_07.mp3"
        ],
        "volume": 0.2
      },
      "deploy": {
        "label": "Schild-Slam",
        "files": [
          "impactPlate_heavy_000.ogg",
          "impactPlate_heavy_001.ogg"
        ],
        "volume": 0.45,
        "randomPitch": true,
        "pitchRange": 0.08
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Sci-Fi Sound Library/Mp3/Menu_Select_01.mp3"
        ],
        "volume": 0.65
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Alien/Alien_Funny_30.mp3",
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Alien/Alien_Funny_31.mp3"
        ],
        "volume": 0.8
      }
    },
    "SentinalLock": {
      "name": "Sentinal Lock",
      "race": "Sul",
      "attack": {
        "label": "Sentinal Spit",
        "files": [
          "more/motions_and_transitions/swish_1.m4a"
        ],
        "volume": 0.15
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/80-CC0-creature-SFX/alien_06.ogg"
        ],
        "volume": 0.65
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/foley/body_hit_02.m4a",
          "more/foley/body_hit_01.m4a",
          "more/foley/body_hit_03.m4a"
        ],
        "volume": 0.5
      }
    },
    "MonitorLock": {
      "name": "Monitor Lock",
      "race": "Sul",
      "attack": {
        "label": "Angriff (Crush/Bite)",
        "files": [
          "even more sounds/RPG Sound Pack/misc/burp.m4a"
        ],
        "volume": 0.7
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Dragon_See_001.m4a"
        ],
        "volume": 0.6
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/Dragon_Kill_001.m4a"
        ],
        "volume": 0.8
      }
    },
    "EnforcerVulture": {
      "name": "Enforcer Vulture",
      "race": "Sul",
      "attack": {
        "label": "Bio-Raketenball Ejektion",
        "files": [
          "more/motions_and_transitions/swish_1.m4a",
          "more/motions_and_transitions/swish_2.m4a"
        ],
        "volume": 0.35
      },
      "spawn": {
        "label": "Spawn (Sul Dreadnought)",
        "files": [
          "even more sounds/80-CC0-creature-SFX/monster_07.ogg"
        ],
        "volume": 0.8
      },
      "death": {
        "label": "Tod (Bersten)",
        "files": [
          "even more sounds/monster/grunt1.m4a",
          "even more sounds/monster/grunt2.m4a"
        ],
        "volume": 0.85
      }
    },
    "LootingVulture": {
      "name": "Looting Vulture",
      "race": "Sul",
      "attack": {
        "label": "Apex Sonnenstrahl Puls",
        "files": [
          "laserLarge_000.ogg",
          "laserLarge_003.ogg"
        ],
        "volume": 0.5
      },
      "spawn": {
        "label": "Spawn (Sul Gold-Leviathan)",
        "files": [
          "even more sounds/monster/deathe.m4a"
        ],
        "volume": 0.65
      },
      "death": {
        "label": "Tod (Goldenes Bersten)",
        "files": [
          "more/animals/dinosaur_hiss.m4a"
        ],
        "volume": 0.85
      },
      "transmute": {
        "label": "Midas Transmutation",
        "files": [
          "even more sounds/PSE Game Audio Sound Pack/MAGShim_Gold Sand Shimmer_PSE_KCV3_qP6sF.m4a"
        ],
        "volume": 0.35
      },
      "statueCrash": {
        "label": "Gold-Monument Bodenaufschlag",
        "files": [
          "impactMining_004.ogg"
        ],
        "volume": 0.95
      }
    },
    "ParasiteVulture": {
      "name": "Parasite Vulture",
      "race": "Sul",
      "spawn": {
        "label": "Spawn (Sul Parasite Leviathan)",
        "files": [
          "even more sounds/monster/deathd.m4a"
        ],
        "volume": 0.65
      },
      "death": {
        "label": "Tod (Bio-Bersten)",
        "files": [
          "more/animals/dinosaur_hiss.m4a"
        ],
        "volume": 0.85
      },
      "overtake": {
        "label": "Parasitäre Übernahme",
        "files": [
          "even more sounds/monster/grunt2.m4a",
          "even more sounds/monster/piggrunt1.m4a"
        ],
        "volume": 0.75
      }
    },
    "AntiShade": {
      "name": "Anti Shade",
      "race": "Sul",
      "attack": {
        "label": "Void-Klingenhieb",
        "files": [
          "more/weapons/sword_1.m4a",
          "even more sounds/PSE Game Audio Sound Pack/WEAPSwrd_Sword Swishes Through Air Fast Whooshes_PSE_OW_ETiv9.m4a"
        ],
        "volume": 0.8,
        "randomPitch": true,
        "pitchRange": 0.08
      },
      "spawn": {
        "label": "Spawn (Schatten-Materialisierung)",
        "files": [
          "even more sounds/80-CC0-creature-SFX/breath.ogg"
        ],
        "volume": 1
      },
      "death": {
        "label": "Tod (Schattenkollaps)",
        "files": [
          "even more sounds/monster/piggrunt1.m4a"
        ],
        "volume": 0.75
      },
      "breath": {
        "label": "Schatten-Atem (Darth Vader Breath)",
        "files": [
          "even more sounds/ghostbreath.mp3"
        ],
        "volume": 0.85,
        "loop": true
      }
    },
    "BlackMarine": {
      "name": "Black Marine",
      "race": "Human",
      "attack": {
        "label": "Angriff (Heavy Gauss)",
        "files": [
          "more/foley/body_hit_02.m4a"
        ],
        "volume": 0.8
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Hero_Kill_001.m4a"
        ],
        "volume": 0.8
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/player/pain5.m4a"
        ],
        "volume": 0.8
      }
    },
    "HyperMarine": {
      "name": "Hyper Marine",
      "race": "Human",
      "attack": {
        "label": "Angriff (Hyper Gauss)",
        "files": [
          "more/foley/body_hit_03.m4a"
        ],
        "volume": 0.85
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Hero_Attack_003.m4a",
          "even more sounds/Hero_Kill_001.m4a",
          "even more sounds/Hero_Taunt_001.m4a"
        ],
        "volume": 0.85
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/player/pain6.m4a",
          "even more sounds/player/pain5.m4a"
        ],
        "volume": 0.7
      }
    },
    "HyperTeslaWalker": {
      "name": "Hyper Tesla Walker",
      "race": "Human",
      "attack": {
        "label": "Angriff (Arc Stream)",
        "files": [
          "baked/tesla_zap.m4a"
        ],
        "volume": 1.5
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Robot/Robot2_02.mp3"
        ],
        "volume": 0.85
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/explosions/explosion_6.m4a"
        ],
        "volume": 0.55
      },
      "hyperTesla": {
        "label": "Ambush Overload",
        "files": [
          "baked/hyper_tesla.m4a"
        ],
        "volume": 0.8
      }
    },
    "HyperDevilPatrol": {
      "name": "Hyper Devil Patrol",
      "race": "Human",
      "attack": {
        "label": "Angriff (Incinerate Burst)",
        "files": [
          "more/weapons/gun_hand_shot_3.m4a"
        ],
        "volume": 0.4
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Human/Human_Evil_08.mp3"
        ],
        "volume": 0.8
      },
      "death": {
        "label": "Tod",
        "files": [
          "more/explosions/explosion_3.m4a",
          "more/explosions/explosion_4.m4a",
          "more/explosions/explosion_5.m4a"
        ],
        "volume": 0.65
      }
    },
    "HyperShade": {
      "name": "Hyper Shade",
      "race": "Human",
      "attack": {
        "label": "Angriff (Suppressed Gauss)",
        "files": [
          "more/weapons/gun_silencer.m4a"
        ],
        "volume": 0.8
      },
      "spawn": {
        "label": "Spawn",
        "files": [
          "more/weapons/sword_1.m4a",
          "even more sounds/Archer_Kill_001.m4a"
        ],
        "volume": 0.2
      },
      "death": {
        "label": "Tod",
        "files": [
          "even more sounds/player/pain5.m4a"
        ],
        "volume": 0.55
      }
    },
    "Stickman": {
      "name": "Stickman",
      "race": "Human",
      "attack": {
        "label": "Angriff (Kinetische Railgun-Lanze)",
        "files": [
          "more/weapons/gun_rifle_shot_1.m4a"
        ],
        "volume": 0.85,
        "randomPitch": true,
        "pitchRange": 0.05
      },
      "spawn": {
        "label": "Spawn / Bereitstellung",
        "files": [
          "even more sounds/Sci-Fi Sound Library/Mp3/Robot_Talk_02.mp3"
        ],
        "volume": 0.8
      },
      "death": {
        "label": "Tod (Slo-Mo Kniefall & Wrack-Kollaps)",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Robot/Robot2_12.mp3"
        ],
        "volume": 0.8
      }
    },
    "Pulp": {
      "name": "Pulp",
      "race": "Sul",
      "attack": {
        "label": "Angriff (Harlekin-Szepter & Mörser)",
        "files": [
          "more/mechtech/gun_hit_fx_01.m4a"
        ],
        "volume": 0.75,
        "randomPitch": true,
        "pitchRange": 0.08
      },
      "spawn": {
        "label": "Spawn (Sul Harlekin)",
        "files": [
          "more/people/laugh_cartoon_5.m4a"
        ],
        "volume": 0.85
      },
      "death": {
        "label": "Tod (Pencil Trick Illusion & Ta-da)",
        "files": [
          "more/motions_and_transitions/low_frequency_flutter_fx_04.m4a"
        ],
        "volume": 0.85
      }
    },
    "HyperPanzer": {
      "name": "Hyper Panzer",
      "race": "Human",
      "attack": {
        "label": "Angriff (Schwere Zwillingskanone)",
        "files": [
          "panzer.m4a",
          "more/weapons/gun_rifle_shot_1.m4a"
        ],
        "volume": 0.8,
        "randomPitch": true,
        "pitchRange": 0.04
      },
      "crush": {
        "label": "Überrollen / Zermalmen (Crush)",
        "files": [
          "explosionCrunch_003.ogg",
          "explosionCrunch_004.ogg"
        ],
        "volume": 0.75,
        "randomPitch": true,
        "pitchRange": 0.1
      },
      "rockets": {
        "label": "Flugabwehr-Raketensalve",
        "files": [
          "explosion_01.ogg"
        ],
        "volume": 0.85
      },
      "spawn": {
        "label": "Spawn / Motorenstart",
        "files": [
          "even more sounds/Voices_Sound_Effect_Library/Mp3/Human/Human_Evil_06.mp3"
        ],
        "volume": 0.85
      },
      "death": {
        "label": "Tod (Supernova-Detonation)",
        "files": [
          "more/explosions/explosion_4.m4a",
          "more/explosions/explosion_5.m4a"
        ],
        "volume": 0.85
      }
    }
  },
  "spells": {
    "spell_conc_charge": {
      "label": "Reconsider (Concentration Charge)",
      "files": [
        "more/sci_fi/filter_sweep_fx_09.m4a"
      ],
      "volume": 0.8
    },
    "spell_conc_burst": {
      "label": "Reconsider (Concentration Burst)",
      "files": [
        "explosion_02.ogg"
      ],
      "volume": 0.8
    },
    "spell_melt_charge": {
      "label": "Melt Fusion (Charge)",
      "files": [
        "baked/melt_charge.m4a"
      ],
      "volume": 0.8,
      "durationMs": 850
    },
    "spell_melt_impact": {
      "label": "Melt Fusion (Impact)",
      "files": [
        "confirmation_004.ogg"
      ],
      "volume": 0.8
    },
    "spell_stun": {
      "label": "Mind Wrack (Stun Schockwelle)",
      "files": [],
      "volume": 0.8
    },
    "spell_buff": {
      "label": "Elite Training / Haste (Buff)",
      "files": [
        "powerUp8.ogg"
      ],
      "volume": 0.8
    },
    "spell_heal": {
      "label": "Shield Overcharge (Heal)",
      "files": [
        "more/motions_and_transitions/bell_cascade_1.m4a"
      ],
      "volume": 0.8
    },
    "spell_clone": {
      "label": "Clone Unit",
      "files": [
        "baked/gold_drop.m4a"
      ],
      "volume": 0.8
    },
    "spell_nuke_alarm": {
      "label": "Nuke Alarm (Sirene)",
      "files": [
        "even more sounds/Sci-Fi Sound Library/Mp3/Alarm_Loop_01.mp3"
      ],
      "volume": 0.9,
      "durationMs": 350
    },
    "bioplasma_hush": {
      "label": "Bio-Plasma Hush (Superweapon)",
      "files": [
        "baked/bioplasma_hush.m4a"
      ],
      "volume": 1.5,
      "durationMs": 900
    },
    "bioplasma_incision": {
      "label": "Bio-Plasma Incision (Einschlag)",
      "files": [
        "explosionCrunch_002.ogg"
      ],
      "volume": 0.8
    },
    "spell_precision_strike_flyby": {
      "label": "Precision Strike (Überflug & Schattenschwingen)",
      "files": [
        "more/sci_fi/whoosh_down_flutter.m4a"
      ],
      "volume": 0.85
    },
    "spell_precision_strike_drop": {
      "label": "Precision Strike (Sporen-Bombe Fall)",
      "files": [
        "more/sci_fi/liquid_drops_fx_01.m4a"
      ],
      "volume": 0.75
    },
    "spell_precision_strike_impact": {
      "label": "Precision Strike (Bio-Detonation & Purpur-Shatter)",
      "files": [
        "more/explosions/explosion_2.m4a"
      ],
      "volume": 0.95
    },
    "spell_fodder": {
      "label": "Fodder (Fallschirmjäger-Abwurf & Signal)",
      "files": [
        "retro_beep_01.ogg"
      ],
      "volume": 0.75
    },
    "spell_mental_extraction": {
      "label": "Mental Extraction (Gedankenraub & Hand-Spiegelung)",
      "files": [
        "more/motions_and_transitions/low_frequency_flutter_fx_03.m4a"
      ],
      "volume": 0.8
    },
    "spell_forced_overstimulation": {
      "label": "Forced Overstimulation (Sul Kampfrausch & Adrenalin)",
      "files": [
        "even more sounds/PSE Game Audio Sound Pack/DSGNRise_Riser Bonzai Pipeline Phasey Hiss_PSE_COL_FpVey.m4a"
      ],
      "volume": 0.85
    },
    "spell_experimental_metamorphosis": {
      "label": "Experimental Metamorphosis (Sul Metamorphose-Nebel & Verpuppung)",
      "files": [
        "baked/bioplasma_hush.m4a",
        "even more sounds/80-CC0-RPG-SFX/spell_fire_03.ogg"
      ],
      "volume": 0.9
    },
    "spell_retreat_protocol": {
      "label": "Retreat Protocol (Sul Rückzugssignal & Tripod Horn)",
      "files": [
        "even more sounds/PSE Game Audio Sound Pack/DSGNBram_Energy Deep Space Growling_PSE_COL_zuwtQ.m4a"
      ],
      "volume": 0.85
    }
  },
  "buildings": {
    "base_cannon_human": {
      "label": "Human Basis — Ibiks-Geschütz",
      "files": [
        "more/weapons/gun_rifle_shot_1.m4a"
      ],
      "volume": 0.6
    },
    "base_energy_sul": {
      "label": "Sul Basis — Energiesphäre",
      "files": [
        "more/motions_and_transitions/crunch_pump_fx.m4a"
      ],
      "volume": 0.2
    },
    "base_destruction": {
      "label": "Basis — Zerstörung & Einsturz",
      "files": [
        "more/explosions/explosion_3.m4a"
      ],
      "volume": 1
    },
    "base_under_attack": {
      "label": "Basis — Unter Beschuss Alarm",
      "files": [
        "beep_01.ogg"
      ],
      "volume": 0.85
    },
    "module_dock_slam": {
      "label": "Modulschacht — Dock Slam",
      "files": [
        "more/mechtech/air_valve_blast.m4a"
      ],
      "volume": 0.8
    }
  },
  "maps": {
    "human": {
      "label": "Human City",
      "music": {
        "files": [
          "loop_ambient_01.ogg"
        ],
        "volume": 0.7
      },
      "ambience": {
        "files": [
          "more/ambience/city_2.m4a"
        ],
        "volume": 0.2
      },
      "rain": {
        "files": [
          "more/ambience/rain_4.m4a"
        ],
        "volume": 0.3
      },
      "wind": {
        "files": [
          "more/ambience/wind_3.m4a"
        ],
        "volume": 0.1
      }
    },
    "sul": {
      "label": "Sul Hive",
      "music": {
        "files": [
          "loop_ambient_weird.ogg"
        ],
        "volume": 0.25
      },
      "ambience": {
        "files": [
          "more/sci_fi/drone_low_pulse.m4a"
        ],
        "volume": 0.2
      },
      "wind": {
        "files": [
          "more/ambience/wind_4.m4a"
        ],
        "volume": 0.3
      }
    },
    "swamp": {
      "label": "Xeno Swamp",
      "music": {
        "files": [],
        "volume": 0.25
      },
      "fog": {
        "files": [
          "more/ambience/wind_haunted.m4a"
        ],
        "volume": 0.1
      },
      "river": {
        "files": [
          "more/ambience/forest_stream_river_water_01.m4a"
        ],
        "volume": 0.1
      },
      "forest_night": {
        "files": [
          "more/ambience/forest_night.m4a"
        ],
        "volume": 0.3
      },
      "country_night": {
        "files": [
          "more/ambience/country_night_02.m4a"
        ],
        "volume": 0.3
      }
    },
    "voidglass": {
      "label": "Voidglass",
      "music": {
        "files": [
          "more/sci_fi/space_ship_interior.m4a"
        ],
        "volume": 0.45
      },
      "wind": {
        "files": [
          "more/ambience/wind_2.m4a"
        ],
        "volume": 0.15
      }
    },
    "stratos": {
      "label": "Stratos",
      "music": {
        "files": [
          "map/map_hardcore.mp3"
        ],
        "volume": 0.45
      },
      "wind": {
        "files": [
          "more/ambience/wind_3.m4a"
        ],
        "volume": 0.18
      }
    },
    "hangar": {
      "label": "Hangar / The Bay",
      "ambience": {
        "files": [],
        "volume": 0.05
      }
    }
  },
  "music": {
    "menu_ost": {
      "label": "Menü-Musik (Start-Pool)",
      "files": [
        "short/loop_chillgroove.mp3",
        "var/menu_sound.mp3"
      ],
      "volume": 0.6
    },
    "menu_rotation_pool": {
      "label": "Menü-Musik (Rotations-Pool)",
      "files": [
        "more/ambience/police_station.m4a",
        "more/sci_fi/space_station_ambience.m4a",
        "even more sounds/Sci-fi freak out.m4a",
        "OST/score.mp3"
      ],
      "volume": 0.6
    },
    "map_human": {
      "label": "Map Human City OST",
      "files": [],
      "volume": 0.7
    },
    "map_sul": {
      "label": "Map Sul Hive OST",
      "files": [],
      "volume": 0.7
    },
    "map_swamp": {
      "label": "Map Xeno Swamp OST",
      "files": [],
      "volume": 0.7
    },
    "map_voidglass": {
      "label": "Map Voidglass OST",
      "files": [],
      "volume": 0.7
    },
    "map_stratos": {
      "label": "Map Stratos OST",
      "files": [],
      "volume": 0.7
    }
  },
  "ui": {
    "card_play": {
      "label": "Karte ausspielen",
      "files": [
        "card-place-2.ogg",
        "card-place-3.ogg",
        "card-place-4.ogg"
      ],
      "volume": 0.7
    },
    "card_draw": {
      "label": "Karte ziehen",
      "files": [
        "card-slide-4.ogg",
        "card-slide-5.ogg",
        "card-slide-6.ogg"
      ],
      "volume": 0.45
    },
    "card_discard": {
      "label": "Karte abwerfen (Consider)",
      "files": [
        "card-shove-1.ogg"
      ],
      "volume": 0.8
    },
    "click_light": {
      "label": "UI Klick (Leicht)",
      "files": [
        "click1.ogg"
      ],
      "volume": 0.6
    },
    "click_medium": {
      "label": "UI Klick (Mittel)",
      "files": [
        "click2.ogg"
      ],
      "volume": 0.7
    },
    "toggle": {
      "label": "UI Schalter / Toggle",
      "files": [
        "click4.ogg"
      ],
      "volume": 0.7
    },
    "modal_open": {
      "label": "Modal öffnen",
      "files": [
        "maximize_003.ogg"
      ],
      "volume": 0.8
    },
    "modal_close": {
      "label": "Modal schließen",
      "files": [
        "minimize_003.ogg"
      ],
      "volume": 0.8
    },
    "error": {
      "label": "Error / Invalid Action",
      "files": [
        "error_006.ogg"
      ],
      "volume": 0.8
    },
    "gold_drop_in": {
      "label": "Goldkarte Alert",
      "files": [
        "even more sounds/PSE Game Audio Sound Pack/MAGShim_Gold Sand Shimmer_PSE_KCV3_qP6sF.m4a"
      ],
      "volume": 0.45
    },
    "onboarding_step": {
      "label": "Onboarding Schritt",
      "files": [
        "confirmation_003.ogg"
      ],
      "volume": 0.8
    },
    "onboarding_finish": {
      "label": "Onboarding Abschluss",
      "files": [
        "confirmation_004.ogg"
      ],
      "volume": 0.8
    },
    "casino_chip_bet": {
      "label": "Casino — Chip setzen",
      "files": [
        "chip-lay-1.ogg"
      ],
      "volume": 0.7
    },
    "casino_chips_win": {
      "label": "Casino — Gewinn",
      "files": [
        "handleCoins.ogg"
      ],
      "volume": 0.8
    },
    "casino_reel_spin": {
      "label": "Casino — Walzendrehung",
      "files": [
        "scroll_002.ogg"
      ],
      "volume": 0.25
    },
    "slot_holo_reveal_new": {
      "label": "Supply Surge — Neuer Unlock (Holo Reveal)",
      "files": [
        "even more sounds/PSE Game Audio Sound Pack/MAGMisc_Energy Magic Spell Energy Electricity Power_PSE_GEN_vmVwR.m4a"
      ],
      "volume": 0.8
    },
    "slot_refund_hexagons": {
      "label": "Supply Surge — Duplicate Refund (Fugazi Schauer)",
      "files": [
        "handleCoins2.ogg",
        "chips-stack-4.ogg"
      ],
      "volume": 0.85
    },
    "crate_drop": {
      "label": "Kiste / Pack Drop",
      "files": [
        "impactPlate_heavy_001.ogg"
      ],
      "volume": 0.8
    },
    "crate_burst": {
      "label": "Kiste / Pack Burst",
      "files": [
        "more/impacts_and_crashes/air_pressure_blast_1.m4a"
      ],
      "volume": 0.8
    }
  },
  "announcer": {
    "round_start": {
      "label": "Runden-Start (Begin)",
      "files": [
        "begin.ogg",
        "deathmatch.ogg",
        "fight.ogg"
      ],
      "volume": 0.9
    },
    "pre_match_hype": {
      "label": "Pre-Match Vorbereitung",
      "files": [
        "prepare_yourself.ogg"
      ],
      "volume": 0.9
    },
    "match_end_stinger": {
      "label": "Match-Ende Stinger",
      "files": [
        "bong_001.ogg"
      ],
      "volume": 0.9
    },
    "victory": {
      "label": "Sieg",
      "files": [
        "confirmation_001.ogg"
      ],
      "volume": 0.9
    },
    "defeat": {
      "label": "Niederlage",
      "files": [
        "lowDown.ogg"
      ],
      "volume": 0.9
    },
    "victory_s_rank": {
      "label": "S-Rang Sieg Fanfare",
      "files": [
        "flawless_victory.ogg"
      ],
      "volume": 0.9
    },
    "level_up": {
      "label": "Level-Up Fanfare",
      "files": [
        "short/xp_level_up.mp3"
      ],
      "volume": 0.9
    },
    "xp_boost": {
      "label": "XP Boost Stinger",
      "files": [
        "short/xp_boost.mp3"
      ],
      "volume": 0.85
    },
    "achievement": {
      "label": "Achievement Reveal",
      "files": [
        "short/achievement.mp3"
      ],
      "volume": 0.9
    },
    "daily_quest": {
      "label": "Daily Quest Completed Pop-Up (Grün)",
      "files": [
        "short/achievement.mp3"
      ],
      "volume": 0.9
    },
    "daily_jackpot": {
      "label": "Daily Jackpot Pop-Up (Gold)",
      "files": [
        "short/achievement.mp3"
      ],
      "volume": 0.95
    }
  },
  "popups": {
    "achievement": {
      "label": "Achievement Unlocked Pop-Up",
      "files": [
        "short/achievement.mp3"
      ],
      "volume": 0.9
    },
    "daily_quest": {
      "label": "Daily Quest Completed Pop-Up (Grün)",
      "files": [
        "even more sounds/PSE Game Audio Sound Pack/UIMisc_Buttons Interface Game Level Up Win_PSE_GEN_yR3GU.m4a"
      ],
      "volume": 1
    },
    "daily_jackpot": {
      "label": "Daily Jackpot Pop-Up (Gold)",
      "files": [
        "confirmation_002.ogg"
      ],
      "volume": 0.95
    },
    "level_up": {
      "label": "Level-Up Pop-Up (Rank Up Banner)",
      "files": [
        "short/xp_level_up.mp3"
      ],
      "volume": 0.9
    }
  },
  "combat_global": {
    "laser_normal": {
      "label": "Laser (Standard)",
      "files": [
        "laser1.ogg",
        "laser2.ogg",
        "laser3.ogg"
      ],
      "volume": 0.7
    },
    "laser_heavy": {
      "label": "Laser (Schwer)",
      "files": [
        "laserLarge_000.ogg",
        "laserLarge_001.ogg",
        "laserLarge_002.ogg"
      ],
      "volume": 0.8
    },
    "gauss": {
      "label": "Gauss Fallback",
      "files": [
        "more/foley/body_hit_02.m4a"
      ],
      "volume": 0.7
    },
    "tesla": {
      "label": "Tesla Zap Fallback",
      "files": [
        "baked/tesla_zap.m4a"
      ],
      "volume": 1.5
    },
    "explosion_small": {
      "label": "Explosion (Klein)",
      "files": [
        "explosion_02.ogg"
      ],
      "volume": 0.6
    },
    "explosion_medium": {
      "label": "Explosion (Mittel)",
      "files": [
        "explosionCrunch_003.ogg"
      ],
      "volume": 0.7
    },
    "explosion_large": {
      "label": "Explosion (Groß)",
      "files": [
        "explosionCrunch_004.ogg"
      ],
      "volume": 0.8
    },
    "explosion_heavy": {
      "label": "Explosion (Schwer)",
      "files": [
        "lowFrequency_explosion_001.ogg"
      ],
      "volume": 0.9
    },
    "explosion_massive": {
      "label": "Explosion (Massiv / Nuke)",
      "files": [
        "lowFrequency_explosion_000.ogg"
      ],
      "volume": 1.3
    },
    "ricochet": {
      "label": "Projektil-Abpraller",
      "files": [
        "metalClick.ogg"
      ],
      "volume": 0.7
    },
    "deflected": {
      "label": "Schild-Ablenkung",
      "files": [
        "forceField_000.ogg"
      ],
      "volume": 0.7
    }
  },
  "barks": {
    "human_select": {
      "label": "Human Select",
      "files": [
        "click2.ogg"
      ],
      "volume": 0.7
    },
    "human_spawn": {
      "label": "Human Spawn (Fallback)",
      "files": [
        "more/weapons/sword_1.m4a"
      ],
      "volume": 0.2
    },
    "human_death": {
      "label": "Human Death (Fallback)",
      "files": [
        "impactSoft_heavy_002.ogg"
      ],
      "volume": 0.7
    },
    "sul_select": {
      "label": "Sul Select",
      "files": [
        "select_001.ogg"
      ],
      "volume": 0.7
    },
    "sul_spawn": {
      "label": "Sul Spawn (Fallback)",
      "files": [
        "baked/sul_spawn.m4a"
      ],
      "volume": 0.6
    },
    "sul_attack": {
      "label": "Sul Attack (Fallback)",
      "files": [
        "more/animals/leopard_snarl.m4a"
      ],
      "volume": 0.7
    },
    "sul_death": {
      "label": "Sul Death (Fallback)",
      "files": [
        "impactSoft_heavy_002.ogg"
      ],
      "volume": 0.7
    }
  },
  "cargo_bay": {
    "hub_navigation": {
      "name": "Hub-Navigation Transit-Beep",
      "archive": {
        "label": "Ziel: Archive",
        "files": [],
        "volume": 1
      },
      "cargo": {
        "label": "Ziel: Cargo Bay",
        "files": [],
        "volume": 1
      },
      "matrix": {
        "label": "Ziel: Mod Matrix",
        "files": [],
        "volume": 1
      },
      "arsenal": {
        "label": "Ziel: Arsenal",
        "files": [],
        "volume": 1
      },
      "exit": {
        "label": "Verlassen / Back to the Void",
        "files": [],
        "volume": 1
      }
    },
    "pack_tab_switch": {
      "label": "Pack-Typ wechseln (Tab / Swipe-Dot)",
      "files": [
        "even more sounds/PSE Game Audio Sound Pack/UIMisc_Buttons Interface Game Level Up Win_PSE_GEN_yR3GU.m4a"
      ],
      "volume": 0.5
    },
    "pack_lock_in": {
      "label": "Beat 1: Lock-In / Pressure Seal",
      "files": [
        "even more sounds/PSE Game Audio Sound Pack/UIMisc_Buttons Interface Game Interface Pleasant Navigation_PSE_GEN_yp2sa.m4a"
      ],
      "volume": 0.5
    },
    "pack_lock_confirm": {
      "label": "Beat 1B: Sekundäres Einrasten (+30ms nach Beat 1)",
      "files": [
        "even more sounds/80-CC0-RPG-SFX/lock_03.ogg"
      ],
      "volume": 1.5
    },
    "pack_charge_tone": {
      "label": "Beat 2: Charge-Up Synth-Tonschicht",
      "files": [
        "more/motions_and_transitions/title_chime_distortion_02.m4a"
      ],
      "volume": 1
    },
    "pack_arc_crack": {
      "label": "Tesla-Lichtbogen Crack (Storm-Bursts & Bridging-Burst)",
      "files": [
        "baked/tesla_zap.m4a",
        "baked/hyper_tesla.m4a"
      ],
      "volume": 1.5
    },
    "pack_latch_snap": {
      "label": "Beat 3: Naht-Bruch / Latch-Snap",
      "files": [
        "more/foley/bone_break_3.m4a"
      ],
      "volume": 1.5
    },
    "pack_latch_click": {
      "label": "Beat 3: Latch-Snap Klick-Layer",
      "files": [
        "more/foley/bone_break_1.m4a"
      ],
      "volume": 1.5
    },
    "pack_detonation_sfx": {
      "label": "Beat 4: Detonation (Sub-Sweep + Noise, Synth)",
      "files": [
        "lowFrequency_explosion_000.ogg"
      ],
      "volume": 1
    },
    "pack_detonation_thump": {
      "label": "Beat 4: Detonation Sub-Bass-Thump",
      "files": [
        "even more sounds/PSE Game Audio Sound Pack/UIMisc_Buttons Interface Game Level Up Win_PSE_GEN_yR3GU.m4a"
      ],
      "volume": 1
    },
    "reveal_ticket_flip": {
      "label": "Reveal: Ticket-Karte umdrehen",
      "files": [
        "card-place-1.ogg",
        "card-place-2.ogg",
        "card-place-3.ogg",
        "card-place-4.ogg"
      ],
      "volume": 1
    },
    "reveal_normal_flip": {
      "label": "Reveal: Normale Karte umdrehen",
      "files": [
        "card-place-1.ogg",
        "card-place-2.ogg",
        "card-place-3.ogg",
        "card-place-4.ogg"
      ],
      "volume": 1
    },
    "warp_speed_ignition": {
      "label": "Warp Speed: Zündung & Screen-Flash",
      "files": [
        "even more sounds/Sci-Fi Sound Library/Mp3/WarpDrive_01.mp3"
      ],
      "volume": 0.85
    },
    "warp_domino_flip": {
      "label": "Warp Speed: Domino-Kartenflip & Laser-Apex",
      "files": [
        "card-place-2.ogg",
        "card-place-3.ogg",
        "card-place-4.ogg"
      ],
      "volume": 1
    }
  },
  "spawns": {
    "suicide_drone": {
      "label": "Suicide Drone (Drone Command)",
      "launch": {
        "label": "Drohnen-Katapult-Start",
        "files": [
          "laserSmall_001.ogg",
          "laserSmall_002.ogg"
        ],
        "volume": 0.75
      },
      "detonation": {
        "label": "Drohnen-Detonation / Einschlag",
        "files": [
          "explosion_01.ogg",
          "explosion_02.ogg"
        ],
        "volume": 0.8
      }
    },
    "invasion_capsule": {
      "label": "Invasion Capsule (Capsule Sling)",
      "launch": {
        "label": "Kapsel-Abschuss / Katapult",
        "files": [
          "more/explosions/explosion_1.m4a"
        ],
        "volume": 0.7
      },
      "impact": {
        "label": "Kapsel-Einschlag & Passagier-Deployment",
        "files": [
          "more/explosions/explosion_3.m4a",
          "explosionCrunch_000.ogg"
        ],
        "volume": 0.85
      }
    },
    "parachute_drop": {
      "label": "Fallschirm-Abwurf (Fodder / Marine-Pilot)",
      "open": {
        "label": "Fallschirm öffnet sich",
        "files": [
          "cloth1.ogg",
          "cloth2.ogg"
        ],
        "volume": 0.65
      },
      "touchdown": {
        "label": "Bodenlandung",
        "files": [
          "more/foley/bodyfall_on_dirt_2.m4a",
          "more/foley/bodyfall_on_dirt_1.m4a"
        ],
        "volume": 0.6
      }
    },
    "sul_cocoon": {
      "label": "Sul Metamorphose-Kokon",
      "form": {
        "label": "Kokon-Verpuppung (Atmosphärischer Sul-Puls)",
        "files": [
          "even more sounds/80-CC0-RPG-SFX/creature_slime_01.ogg"
        ],
        "volume": 0.85
      },
      "hatch": {
        "label": "Kokon-Schlupf (Einheit bricht hervor)",
        "files": [
          "even more sounds/80-CC0-RPG-SFX/creature_slime_04.ogg"
        ],
        "volume": 0.9
      }
    },
    "sul_symbiosis": {
      "label": "Sul Symbiose-Spawn",
      "spawn": {
        "label": "Sul Verschmelzungs- & Rekombinations-Spawn",
        "files": [
          "baked/sul_spawn.m4a"
        ],
        "volume": 0.85
      }
    },
    "stickman_obstacle": {
      "label": "Stickman Wrack-Hindernis",
      "collapse": {
        "label": "Wrack-Kollaps / Funkenregen",
        "files": [
          "even more sounds/80-CC0-RPG-SFX/metal_01.ogg"
        ],
        "volume": 0.85
      },
      "lance_impact": {
        "label": "Lanzen-Einschlag im Felsgestein",
        "files": [
          "more/foley/bodyfall_on_dirt_2.m4a"
        ],
        "volume": 0.8
      }
    }
  }
};
